/* eslint-disable */
import throwI18nInvalidShortLabelLengthError from '../../../Errors/I18n/I18nInvalidShortLabelLength.error';
import throwI18nInvalidShortLabelTypeError from '../../../Errors/I18n/I18nInvalidShortLabelType.error';
import isString from '../../Is/String/IsString.support';

/**
 * Determine if a provided `shortLabel` is indeed a valid `shortLabel`
 * @export
 * @param {string} shortLabel The `shortLabel` to check
 * @returns {boolean} Whether or not the provided `shortLabel` is indeed valid
 */
const i18nValidateShortLabel = (shortLabel) => {
  if (!isString(shortLabel)) {
    return throwI18nInvalidShortLabelTypeError(shortLabel);
  }
  if (shortLabel.length === 0) {
    return throwI18nInvalidShortLabelLengthError(shortLabel);
  }
  return true;
};

export default i18nValidateShortLabel;
